export default __webpack_public_path__ + "static/media/w1.5b333405.jpg";